import React, { useCallback, useState } from 'react';
import { AccordionItem, Box, Inscription, LinkButton } from '@common-fe/common-fe';

import { ROUTES } from '@/common';

import { Renewal } from '../../renewals.types'; 
import { SummaryBox } from '../styles/RenewalSetup.styles';

import { CopaysSummaryContainer } from './CopaysSummaryContainer';

interface Props {
  renewalSetupData?: Renewal;
}

const CopaysSummary: React.FC<Props> = ({
  renewalSetupData,
}) => {
  const [isExpanded, setExpanded] = useState(false);
    const handleOpenCopays = useCallback(() => {
      window.open(
        `${ROUTES.COPAY_ADJUDICATION}${window.location.search}`,
        '_blank'
      );
    }, []);

  return (
    <SummaryBox
      onClick={() => setExpanded(!isExpanded)}
      pad={{ vertical: 's', horizontal: 'm' }}
      border={{ color: 'border1', size: 'large' }}
      margin={{ bottom: 'l' }}
      round="container1Round"
      background={isExpanded ? 'border1' : 'canvas'}
    >
      <AccordionItem
        testId='copays-summary-item'
        iconSize='24px'
        isExpanded={isExpanded}
        text={(
          <Box
            background={isExpanded ? 'border1' : 'canvas'}
            margin={{ left: 'xxxs' }}
            direction="row"
            align="center"
          >
            <Inscription color="textBody" weight="normal" lineHeight='20px'>
              Summary of your current copays
            </Inscription>
          </Box>
        )}
        isLeftArrow
      >    
        <Box
          background="border1"
          margin={{ top: 's' }}
        >
          <CopaysSummaryContainer
            copays={renewalSetupData?.copays}
          />
          <Box margin={{ top: 'xs'}}>
            <LinkButton onClick={handleOpenCopays} style={{ margin: 'xs' }}linkInlineMode>Open Copays</LinkButton>
          </Box>
        </Box>
      </AccordionItem>
    </SummaryBox>
  );
};

export default CopaysSummary;
